export default __webpack_public_path__ + "static/N0162-83dc595b6f000f8507d9f959d4c90331.png";